import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'pagination';
let loaded = loadState(STORE_KEY) || [];

const state = {
	pagesArray: loaded.pagesArray || [],
	totalPages: loaded.totalPages || [],
	currentPage: loaded.currentPage || 1,
};

const mutations = {
	SET_PAGINATION_ARRAY(state, pages) {
		state.pagesArray = pages;
		saveState(STORE_KEY, state);
	},
	SET_CURRENT_PAGE(state, page) {
		state.currentPage = page;
		saveState(STORE_KEY, state);
	},
	SET_TOTAL_PAGES(state, total) {
		state.totalPages = total;
		saveState(STORE_KEY, state);
	},
};

const actions = {
	setPagesArray({ commit }, pages) {
		commit('SET_PAGINATION_ARRAY', pages);
	},

	setCurrentPage({ commit }, page) {
		commit('SET_CURRENT_PAGE', page);
	},
	setTotalPages({ commit }, total) {
		commit('SET_TOTAL_PAGES', total);
	},
};

const getters = {
	selectPages: (state) => state.pagesArray,
	currentPage: (state) => state.currentPage,
	totalPages: (state) => state.totalPages,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
